<div class="technical-info">
  <div class="technical-info__column">
    <gen-info-lines class="technical-info-lines" [sourceData]="diagnosticOrder$ | async" [title]="pcrRunTitle" [fieldsToDisplay]="pcrRunFields" [translationPrefix]="'processing'"></gen-info-lines>
    <gen-info-box class="technical-info-box" *ngIf="thermalWarning$ | async" [iconType]="'info'" [message]="thermalWarningMessage" [borderCss]="'__border'"></gen-info-box>
  </div>
  <div class="technical-info__column">
    <div class="technical-info-title">PCR Results</div>
    <gen-pcr-graph *ngIf="reactDataList$ | async as reactDataList" [graphCoordinates]="reactDataList"></gen-pcr-graph>
  </div>
</div>
